// extracted by mini-css-extract-plugin
export default {"pillsContainer":"PillsToolbar_pillsContainer__WL1bQ","pill":"PillsToolbar_pill__UIFnP","pillBorder":"PillsToolbar_pillBorder__Y8JU-"};